import { makeAutoObservable, runInAction } from "mobx";
import i18n from "i18n";
import {
    pagingRelatedPersons,
    getRelatedPerson,
    createRelatedPerson,
    editRelatedPerson,
    deleteRelatedPerson
} from "../../RelatedPerson/RelatedPersonService";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import LocalConstants from "app/LocalConstants";
import { getEtbAll } from "../Services/PatientService";

export default class EtbRelatedPersonStore {
    relatedPersonList = [];
    selectedRelatedPerson = null;
    selectedRelatedPersonList = [];
    totalElements = 0;
    totalPages = 0;
    page = 1;
    rowsPerPage = 10;
    keyword = "";
    editable = false;
    loadingInitial = false;
    shouldOpenEditorDialog = false;
    shouldOpenConfirmationDialog = false;
    shouldOpenConfirmationDeleteListDialog = false;
    patientId= null;
    searchObject = {
        patient: null,
        type: null
    };
    defaultRelatedPerson = {
        id: "",
        name: "",
        type: null,
        gender: null,
        birthDate: null,
        medicalExamination: false,
        objectManagement: null,
        monitoringDay: new Date(),
        informationExtractionDay: null,
        note: "",
        organizationDto: null,
        administrativeUnit: null,
        age: null,
        department: null,
        patient: {
            id: ""
        },
        idNumber: "",
        idCitizen: ""
    }

    constructor() {
        makeAutoObservable(this);
    }

    setLoadingInitial = (state) => {
        this.loadingInitial = state;
    };

    updatePageData = (item) => {

        if (item != null) {
            this.page = 1;
            this.keyword = item.keyword;
            this.search();
        } else {
            this.search();
        }
    };
    setPatientIdOfRelatedPerson = (patientId) =>{
        this.patientId = patientId;
    }
    search = async () => {
        this.loadingInitial = true;
        var searchObject = {
            keyword: this.keyword,
            pageIndex: this.page,
            pageSize: this.rowsPerPage,
            patientId: this.patientId,
            type: this.searchObject.type,
        }
        try {
            let data = await pagingRelatedPersons(searchObject);
            runInAction(() => {
                this.relatedPersonList = data.data?.content;
                this.selectedRelatedPerson = data.data.content?.[0];
                this.totalElements = data.data.totalElements;
                this.totalPages = data.data.totalPages;
            })
            this.setLoadingInitial(false);
        } catch (error) {
            console.log(error);
            toast.warning(i18n.t("toast.error"));
            this.setLoadingInitial(false);
        }
    };

    setPage = (page) => {
        this.page = page;
        this.updatePageData();
    };

    setRowsPerPage = (event) => {
        this.rowsPerPage = event.target.value;
        this.page = 1;
        this.updatePageData();
    };

    handleSetSearchObject = (item) => {
        if (item.pageIndex) {
            this.page = item.pageIndex;
        }
        this.searchObject = item;
    }

    handleChangePage = (event, newPage) => {
        this.setPage(newPage);
    };

    handleEditRelatedPerson = (id) => {
        this.getRelatedPerson(id).then(() => {

        });
    };

    handleClose = () => {
        this.shouldOpenEditorDialog = false;
        this.shouldOpenConfirmationDialog = false;
        this.shouldOpenConfirmationDeleteListDialog = false;
        this.updatePageData();
    };

    handleDelete = (id) => {
        this.getRelatedPerson(id).then(() => {
            this.shouldOpenConfirmationDialog = true;
        });
    };

    handleDeleteList = () => {
        this.shouldOpenConfirmationDeleteListDialog = true;
    };

    handleConfirmDelete = async () => {
        try {
            const res = await deleteRelatedPerson(this.selectedRelatedPerson.id);
            if (res?.data) {
                toast.success(i18n.t("toast.delete_success"));
            } else {
                toast.warningi18n.t("toast.delete_fail");
            }
            this.handleClose();
            return res;
        } catch (error) {
            console.log(error);
            toast.error(i18n.t("toast.error"));
        }
    };

    handleConfirmDeleteList = async () => {
        let listAlert = [];
        for (var i = 0; i < this.selectedRelatedPersonList.length; i++) {
            try {
                await deleteRelatedPerson(this.selectedRelatedPersonList[i].id);
            } catch (error) {
                listAlert.push(this.selectedRelatedPersonList[i].name);
                toast.warning(i18n.t("toast.error"));
            }
        }
        this.handleClose();
        toast.success(i18n.t("toast.delete_success"));
    };

    getRelatedPerson = async (id) => {
        if (id != null) {
            try {
                let data = await getRelatedPerson(id);
                this.handleSelectRelatedPerson(data.data);
            } catch (error) {
                console.log(error);
                toast.warning(i18n.t("toast.error"));
            }
        } else {
            this.handleSelectRelatedPerson(null);
        }
    };

    handleSelectRelatedPerson = (relatedPerson) => {
        this.selectedRelatedPerson = relatedPerson;
    };

    handleSelectListRelatedPerson = (relatedPersons) => {
        this.selectedRelatedPersonList = relatedPersons;
        console.log(this.selectedRelatedPersonList);
    };

    createRelatedPerson = async (relatedPerson) => {
        try {
            await createRelatedPerson(relatedPerson);
            toast.success(i18n.t("toast.add_success"));
            this.handleClose();
        } catch (error) {
            console.log(error);
            toast.warning(i18n.t("toast.add_fail"));
        }
    };

    editRelatedPerson = async (relatedPerson) => {
        try {
            await editRelatedPerson(relatedPerson);
            toast.success(i18n.t("toast.update_success"));
            this.handleClose();
        } catch (error) {
            console.log(error);
            toast.warning(i18n.t("toast.update_fail"));
        }
    };
    setEditable = (value) => {
        this.editable = value;
    }
    getEtbAllRealtePerson = async (patientId, id) => {
        if (patientId != null) {
          const obj = {
            patientId: patientId,
            typeBook: LocalConstants.TypeBook?.[2]?.value,
          }
          try {
            let res = await getEtbAll(obj);
            return res.data;
          } catch (error) {
            console.log(error);
            toast.warning(i18n.t("toast.error"));
          }
        }
      };
}
